import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CGISeverityModule } from 'modules/promptuary/components/cgi-severity/cgi-severity.module';
import { VCHistoryModule } from 'modules/video-conference/components/vc-history/vc-history.module';
import { TabPanelModule } from 'shared/components/tab-panel/tab-panel.module';
import { TabModule } from 'shared/components/tab/tab.module';

import { AppointmentDetailsAlertModule } from '../appointment-details-alert/appointment-details-alert.module';
import { AppointmentDetailsHistoricTabModule } from '../appointment-details-historic-tab/appointment-details-historic-tab.module';
import { AppointmentDetailsPaymentDataModule } from '../appointment-details-payment-data/appointment-details-payment-data.module';
import { AppointmentDetailsSessionDataModule } from '../appointment-details-session-data/appointment-details-session-data.module';
import { AppointmentDetailsTasksModule } from '../appointment-details-tasks/appointment-details-tasks.module';
import { AppointmentDetailsTriageDataModule } from '../appointment-details-triage-data/appointment-details-triage-data.module';
import { AppointmentDetailsBodyComponent } from './appointment-details-body.component';

@NgModule({
	declarations: [AppointmentDetailsBodyComponent],
	exports: [AppointmentDetailsBodyComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		AppointmentDetailsPaymentDataModule,
		AppointmentDetailsSessionDataModule,
		AppointmentDetailsTriageDataModule,
		AppointmentDetailsAlertModule,
		AppointmentDetailsHistoricTabModule,
		TabPanelModule,
		TabModule,
		VCHistoryModule,
		CGISeverityModule,
		AppointmentDetailsTasksModule,
	],
})
export class AppointmentDetailsBodyModule {}
